import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import CachedRoundedIcon from '@mui/icons-material/CachedRounded';
import { Chip } from '@mui/material';
import color from 'color';
import { useMemo } from 'react';
import { TwemojiWrapper } from '../../../components/twemojiWrapper';
import { HeaderTitle } from '../../../header/headerTitle';
import { FireIcon } from '../../../icons/fireIcon';
import { useAppSelector } from '../../../redux/store';
import { ALL_IN_GAME_DARK_RED_COLOR, ALL_IN_GAME_LIGHT_RED_COLOR, HEADER_BACKGROUND_COLOR, HEADER_SUBTITLE_COLOR } from '../../../styles/colors';
import { ALL_POKER_VARIANT_PROPERTIES } from '../../../types/pokerVariantTypes';
import { ALL_CREATE_ROOM_TYPE_PROPERTIES } from '../../../types/sharedTypes';
import { getHtmlTextContent } from '../../../utils/htmlUtils';
const ROOM_NAME_CSS = css `
  color: #aaa;
`;
function createChipCss(color, backgroundColor) {
    return css `
    &.MuiChip-root {
      color: ${color};
      background-color: ${backgroundColor};
      vertical-align: sub;
    }
    .MuiChip-icon {
      color: ${color};
    }
  `;
}
const MIXED_GAME_CHIP_CSS = createChipCss(HEADER_SUBTITLE_COLOR, color(HEADER_SUBTITLE_COLOR).mix(color(HEADER_BACKGROUND_COLOR), 0.65).hex());
const ALL_IN_GAME_CHIP_CSS = createChipCss(ALL_IN_GAME_LIGHT_RED_COLOR, ALL_IN_GAME_DARK_RED_COLOR);
export const PokerHeaderTitle = () => {
    const pokerVariantShortName = useAppSelector((state) => state.poker.pokerVariant ? ALL_POKER_VARIANT_PROPERTIES[state.poker.pokerVariant].shortName : undefined);
    const roomName = useAppSelector((state) => state.poker.roomName);
    const isAllInGame = useAppSelector((state) => state.poker.isAllInGame);
    const isMixedGame = useAppSelector((state) => state.poker.isMixedGame);
    const tourneyTypeLabel = useAppSelector((state) => {
        if (!state.poker.tourneyProperties) {
            return;
        }
        return state.poker.tourneyProperties.isMtt ? 'MTT' : 'TOURNEY';
    });
    // If the room name had HTML characters in it such as < or >, these will result in '&lt;' and '&gt;' so we need to convert them back:
    const parsedRoomName = useMemo(() => getHtmlTextContent(roomName || ''), [roomName]);
    if (!pokerVariantShortName || !parsedRoomName) {
        // add an empty 'filler' HeaderTitle element that will take up remaining space so right side panel controls will be right-justified:
        return _jsx(HeaderTitle, {});
    }
    const getVariantLabel = () => {
        if (isMixedGame) {
            return (_jsx(Chip, { css: MIXED_GAME_CHIP_CSS, label: pokerVariantShortName.toUpperCase(), size: 'small', icon: _jsx(CachedRoundedIcon, {}), title: `Mixed Game (currently ${pokerVariantShortName})` }));
        }
        if (isAllInGame) {
            return (_jsx(Chip, { css: ALL_IN_GAME_CHIP_CSS, label: ALL_CREATE_ROOM_TYPE_PROPERTIES['all-insanity'].name.toUpperCase(), size: 'small', icon: _jsx(FireIcon, {}) }));
        }
        return pokerVariantShortName.toUpperCase();
    };
    const variantLabel = getVariantLabel();
    const subTitle = tourneyTypeLabel ? (_jsxs(_Fragment, { children: [variantLabel, " ", tourneyTypeLabel] })) : (variantLabel);
    return (_jsx(HeaderTitle, { title: _jsx("span", { css: ROOM_NAME_CSS, title: 'Room Name', children: _jsx(TwemojiWrapper, { children: parsedRoomName }) }), subTitle: _jsx("span", { title: 'Game Type', children: subTitle }) }));
};
